<template>
  <div>
    <Head :title="`KATEGORIE: ${form.test}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/backend/category">KATEGORIE</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.text }}
    </h1>
    <trashed-message v-if="category.deleted_at" class="mb-6" @restore="restore"> Das ist eine gelöschte KATEGORIE. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.text" :error="form.errors.text" class="pb-8 pr-6 w-full lg:w-full" label="Text" />
          <text-input v-model="form.order" :error="form.errors.order" class="pb-8 pr-6 w-full lg:w-full" label="Reihenfolge" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!category.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">KATEGORIE löschen</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">KATEGORIE speichern</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    category: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        text: this.category.text,
        order: this.category.order,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/backend/category/${this.category.id}`)
    },
    destroy() {
      if (confirm('Sind Sie sicher, dass Sie diese KATEGORIE löschen wollen?')) {
        this.$inertia.delete(`/backend/category/${this.category.id}`)
      }
    },
    restore() {
      if (confirm('Sind Sie sicher, dass Sie diese KATEGORIE wieder herstellen wollen?')) {
        this.$inertia.put(`/backend/category/${this.category.id}/restore`)
      }
    },
  },
}
</script>
